/**
 * Helpers de logging: solo en desarrollo para no exponer datos ni ralentizar producción.
 * Uso: logger.debug('mensaje', data) o devLog('mensaje', data).
 */
const isDev = typeof import.meta !== 'undefined' && import.meta.env?.DEV === true;

/** Logger condicional: debug/info solo en DEV; warn/error siempre visibles */
export const logger = {
  debug: (...args: unknown[]) => isDev && console.log(...args),
  info: (...args: unknown[]) => isDev && console.info(...args),
  warn: (...args: unknown[]) => console.warn(...args),
  error: (...args: unknown[]) => console.error(...args),
};

export function devLog(...args: unknown[]): void {
  if (isDev) {
    console.log(...args);
  }
}

export function devWarn(...args: unknown[]): void {
  if (isDev) {
    console.warn(...args);
  }
}

export function devInfo(...args: unknown[]): void {
  if (isDev) {
    console.info(...args);
  }
}
